/* Auzi Bespoke Wizard - no alternate submission endpoint; Shopify Forms is authoritative. */
(() => {
  'use strict';
  const root=document.querySelector('[data-auzi-bespoke-wizard]');
  if(!root||root.dataset.ready==='1')return;
  root.dataset.ready='1';
  const el=(selector)=>root.querySelector(selector);
  const dialog=el('.awb-dialog');
  const steps=Array.from(root.querySelectorAll('[data-awb-step]'));
  const next=el('[data-awb-next]'),back=el('[data-awb-back]');
  const count=el('[data-awb-count]'),bar=el('[data-awb-bar]'),slot=el('[data-awb-form-slot]');
  const notice=el('[data-awb-form-notice]'),loading=el('[data-awb-form-loading]');
  const knowWrap=el('[data-awb-know-wrap]'),chooser=el('[data-awb-device-chooser]');
  const deviceName=el('[data-awb-device-name]'),idea=el('#awb-idea');
  const photo=el('#awb-photo'),photoName=el('[data-awb-photo-name]');
  const budgetInput=el('#awb-budget'),currencyWrap=el('.awb-budget-field');
  const nameInput=el('#awb-name'),emailInput=el('#awb-email'),contact=el('[data-awb-contact]');
  const send=el('[data-awb-submit]'),complete=el('[data-awb-complete]');
  const copy=JSON.parse(el('[data-awb-copy]').textContent);
  const formSection=document.querySelector('[id$="__'+root.dataset.formSection+'"]');
  const state={step:0,forWhom:'',knows:null,device:null,later:false,idea:'',budget:'',photo:null};
  let fillPromise=null;
  let opener,bodySnapshot,formMoved=false,submitting=false,successMonitor=null,submittedForm=null;
  const currencyCode=(currencyWrap?.dataset.awbCurrency||'GBP').toUpperCase();
  const locale=currencyWrap?.dataset.awbLocale||'en';

  // Stable, rounded minimum spend by presentment currency.
  // Do not expose raw FX conversions or prices with odd decimals.
  const currencyMinimums=Object.freeze({
    GBP:400, EUR:450, USD:500, CAD:750, AUD:800, NZD:900,
    CHF:450, DKK:3500, SEK:5500, NOK:5500, PLN:2000,
    CZK:12000, HUF:200000, RON:2500, RSD:60000,
    BGN:900, HRK:3500, TRY:25000, BRL:3000,
    JPY:80000, KRW:750000, CNY:4000, HKD:4000, TWD:20000,
    SGD:700, MYR:2500, THB:20000, IDR:10000000,
    PHP:30000, VND:15000000, INR:50000, PKR:150000,
    AED:2000, SAR:2000, QAR:2000, KWD:150, BHD:200,
    OMR:200, ILS:2000, ZAR:10000, EGP:30000,
    MXN:11000, COP:2500000, CRC:350000, CLP:600000,
    PEN:2000, ARS:700000, UYU:25000, ISK:75000,
    RUB:50000, UAH:25000, KZT:300000, MAD:5500,
    NGN:850000, KES:75000
  });
  const minimumLabel=el('[data-awb-budget-minimum]');
  const budgetError=el('[data-awb-budget-error]');
  const shopifyRate=Number(window.Shopify?.currency?.rate);
  const niceIncrement=shopifyRate>=100?1000:shopifyRate>=10?100:shopifyRate>=1?50:25;
  const minimumBudget=currencyMinimums[currencyCode]||(
    Number.isFinite(shopifyRate)&&shopifyRate>0
      ? Math.ceil(400*shopifyRate/niceIncrement)*niceIncrement : null
  );
  const formatMinimum=(value,code=currencyCode)=>{
    try{return new Intl.NumberFormat(locale,{style:'currency',currency:code,currencyDisplay:'narrowSymbol',maximumFractionDigits:0,minimumFractionDigits:0}).format(value);}
    catch{return value+' '+code;}
  };
  const minFormatted=minimumBudget===null?formatMinimum(400,'GBP'):formatMinimum(minimumBudget);
  const minCopy=value=>String(value||'').replace(/\{amount\}/g,minFormatted);
  if(minimumLabel)minimumLabel.textContent=minCopy(
    minimumBudget===null?copy.budget_minimum_equivalent:copy.budget_minimum
  );
  const bmark=el('[data-awb-currency-symbol]');
  try{
    const parts=new Intl.NumberFormat(locale,{style:'currency',currency:currencyCode,currencyDisplay:'narrowSymbol'}).formatToParts(0);
    bmark.textContent=parts.find(p=>p.type==='currency')?.value||currencyCode;
  }catch{bmark.textContent=currencyCode;}
  // The app remains on the page as a normal functioning form without JavaScript.
  if(formSection){formSection.style.display='none';formSection.dataset.auziNativeBespoke='true';}
  const showNotice=(message)=>{notice.textContent=message||'';notice.hidden=!message;};
  function freeze(){
    if(bodySnapshot)return;
    const y=window.scrollY||0,s=document.body.style;
    bodySnapshot={y,position:s.position,top:s.top,left:s.left,right:s.right,width:s.width,overflow:s.overflow};
    Object.assign(s,{position:'fixed',top:'-'+y+'px',left:'0',right:'0',width:'100%',overflow:'hidden'});
    document.documentElement.classList.add('auzi-bespoke-wizard-open');
  }
  function thaw(){
    const x=bodySnapshot;if(!x)return;
    bodySnapshot=null;const s=document.body.style;
    for(const k of ['position','top','left','right','width','overflow'])s[k]=x[k];
    document.documentElement.classList.remove('auzi-bespoke-wizard-open');
    const old=document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior='auto';
    window.scrollTo(0,x.y);document.documentElement.style.scrollBehavior=old;
  }
  function showStep(index){
    state.step=Math.max(0,Math.min(index,4));
    steps.forEach((step,i)=>{step.hidden=i!==state.step;});
    count.textContent=(state.step+1)+' / 5';bar.style.width=((state.step+1)*20)+'%';
    back.hidden=state.step===0||complete?.hidden===false;
    next.hidden=state.step===0||state.step===4;
    if(state.step===1){
      const head=el('[data-awb-device-heading]');
      if(head)head.textContent=state.forWhom==='gift'?head.dataset.forGift:head.dataset.forSelf;
      el('[data-awb-open-picker]').dataset.adGift=state.forWhom==='gift'?'true':'false';
      knowWrap.hidden=state.forWhom!=='gift'||state.knows!==null;
      chooser.hidden=state.forWhom==='gift'&&state.knows===null;
      next.hidden=state.forWhom==='gift'&&state.knows===null;
      deviceName.textContent=state.device?[state.device.brand,state.device.model].filter(Boolean).join(' '):'';
      deviceName.hidden=!state.device;
    }
    if(state.step===4){
      state.idea=idea.value.trim();ensureNativeForm();
      syncNative().catch(()=>{});
      // App embed renders asynchronously. Native-field sync runs on submission.
    }
    const pane=el('.awb-scroll');if(pane)pane.scrollTop=0;
    requestAnimationFrame(()=>{
      if(!dialog.open)return;
      const head=steps[state.step].querySelector('h2');
      head?.setAttribute('tabindex','-1');head?.focus({preventScroll:true});
    });
  }
  function openWizard(trigger){
    if(typeof dialog.showModal!=='function'){
      if(formSection){formSection.style.display='';formSection.scrollIntoView({block:'start'});}
      return;
    }
    opener=trigger||document.activeElement;freeze();
    try{dialog.showModal();}catch{thaw();return;}
    showStep(state.step);
  }
  function closeWizard(){if(dialog.open)dialog.close();}
  dialog.addEventListener('close',()=>{thaw();opener?.focus?.({preventScroll:true});});
  el('[data-awb-close]').addEventListener('click',closeWizard);
  el('[data-awb-finish]').addEventListener('click',closeWizard);
  // Capture before old scroll-to-form handlers.
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.('[data-auzi-bespoke-jump],[data-auzi-bespoke-wizard-open]');
    if(!trigger)return;
    event.preventDefault();event.stopImmediatePropagation();openWizard(trigger);
  },true);
  root.querySelectorAll('[data-awb-person]').forEach(button=>button.addEventListener('click',()=>{
    state.forWhom=button.dataset.awbPerson;
    state.knows=state.forWhom==='self'?true:null;
    state.device=null;state.later=false;showStep(1);
  }));
  root.querySelectorAll('[data-awb-knows]').forEach(button=>button.addEventListener('click',()=>{
    state.knows=button.dataset.awbKnows==='yes';
    if(!state.knows){state.device=null;state.later=true;showStep(2);}
    else{state.later=false;showStep(1);el('[data-awb-open-picker]').focus({preventScroll:true});}
  }));
  el('[data-awb-unknown]').addEventListener('click',()=>{state.later=true;state.device=null;showStep(2);});
  // Exactly the device chosen through the existing Auzi picker is retained.
  document.addEventListener('auzi:device-confirmed',event=>{
    if(!dialog.open||event.detail?.context!=='bespoke')return;
    state.device=event.detail?.device||null;
    state.knows=true;state.later=false;
    deviceName.textContent=[state.device?.brand,state.device?.model].filter(Boolean).join(' ');
    deviceName.hidden=!state.device;
    const picker=document.querySelector('auzi-device-picker dialog');
    if(picker?.open){
      // After the picker closes, advance with no additional wizard Continue.
      picker.addEventListener('close',()=>{if(dialog.open&&state.step===1)showStep(2);},{once:true});
    }else if(state.step===1)showStep(2);
  });
  // The picker can be dismissed without making a choice: stay on device step.
  const fileAccept=/^(image\/jpeg|image\/png|image\/webp|image\/heic|image\/gif|application\/pdf)$/;
  photo.addEventListener('change',()=>{
    const file=photo.files?.[0]||null;
    if(file&&(file.size>20*1024*1024||!(fileAccept.test(file.type)||/\.(heic|heif)$/i.test(file.name)))){
      photo.value='';state.photo=null;photoName.textContent=copy.file_error;return;
    }
    state.photo=file;photoName.textContent=file?.name||'';
  });
  function amount(){
    // Accept Arabic-Indic, Persian and full-width digits as well as Western digits.
    const raw=budgetInput.value.trim()
      .replace(/[٠-٩]/g,c=>String(c.charCodeAt(0)-0x0660))
      .replace(/[۰-۹]/g,c=>String(c.charCodeAt(0)-0x06f0))
      .replace(/[０-９]/g,c=>String(c.charCodeAt(0)-0xff10))
      .replace(/٫/g,'.').replace(/٬/g,',')
      .replace(/[^\d.,]/g,'');
    if(!raw||!/^[\d.,]+$/.test(raw))return null;
    // Accept either '1000', '1.000,00', '1,000.00', '1000,50'.
    const pos=Math.max(raw.lastIndexOf('.'),raw.lastIndexOf(','));
    const decimals=pos>=0&&raw.length-pos-1>=1&&raw.length-pos-1<=2;
    const numbers=decimals?raw.slice(0,pos).replace(/[.,]/g,'')+'.'+raw.slice(pos+1):raw.replace(/[.,]/g,'');
    const value=Number(numbers);
    return Number.isFinite(value)&&value>0&&value<1000000000?value:null;
  }
  next.addEventListener('click',()=>{
    if(state.step===1){if(state.device||state.later)showStep(2);else el('[data-awb-open-picker]').focus();return;}
    if(state.step===2){if(!idea.value.trim()){idea.focus();idea.reportValidity();return;}state.idea=idea.value.trim();showStep(3);return;}
    if(state.step===3){
      const value=amount();
      const invalid=value===null;
      const tooLow=!invalid&&minimumBudget!==null&&value<minimumBudget;
      if(invalid||tooLow){
        budgetError.textContent=tooLow?minCopy(copy.budget_below_minimum):copy.budget_error;
        budgetError.hidden=false;
        budgetInput.setAttribute('aria-invalid','true');
        budgetInput.focus();
        return;
      }
      budgetError.hidden=true;
      budgetInput.removeAttribute('aria-invalid');
      state.budget=new Intl.NumberFormat('en-GB',{maximumFractionDigits:2}).format(value);
      showStep(4);
    }
  });
  budgetInput.addEventListener('input',()=>{
    budgetError.hidden=true;
    budgetInput.removeAttribute('aria-invalid');
  });
  back.addEventListener('click',()=>{if(!submitting&&state.step>0)showStep(state.step-1);});
  function enquiryText(){
    return [
      'Bespoke enquiry',
      'For: '+(state.forWhom==='gift'?copy.gift:copy.self),
      'Device: '+(state.device?[state.device.brand,state.device.model].filter(Boolean).join(' '):copy.later),
      'Design: '+state.idea,
      'Budget: '+state.budget+' '+currencyCode
    ].join('\n');
  }
  function ensureNativeForm(){
    if(formMoved)return true;
    if(!formSection){showNotice(copy.form_unavailable);return false;}
    slot.appendChild(formSection);
    formSection.style.display='';formSection.style.margin='0';formSection.style.padding='0';
    formMoved=true;loading.hidden=true;return true;
  }
  // Collect fields through accessible shadow roots used by Shopify Forms.
  function within(node,selector){
    const out=[];
    const walk=rootNode=>{
      if(!rootNode)return;
      rootNode.querySelectorAll?.(selector).forEach(n=>out.push(n));
      rootNode.querySelectorAll?.('*').forEach(n=>{if(n.shadowRoot)walk(n.shadowRoot);});
    };
    walk(node);return out;
  }
  function describe(field){
    const ctx=field.getRootNode(),id=field.id;
    const label=field.labels?.[0]?.textContent|| (id?ctx.querySelector?.('label[for="'+CSS.escape(id)+'"]')?.textContent:'')||'';
    return [field.type,field.name,field.id,field.placeholder,field.getAttribute('aria-label'),label].join(' ').toLowerCase();
  }
  function setNative(field,value){
    if(!field||value===undefined||value===null||field.type==='checkbox'||field.type==='radio')return false;
    if(field.tagName==='SELECT'){
      const sought=String(value).toLowerCase();
      const opts=Array.from(field.options||[]);
      const match=opts.find(o=>o.value.toLowerCase()===sought||o.textContent.trim().toLowerCase()===sought)||
        opts.find(o=>o.textContent.toLowerCase().includes(sought))||
        (/later|not sure|unknown|other/i.test(sought)?opts.find(o=>/other|unknown|not sure|don't know|unsure|later|autre|sonstige|weiß nicht/i.test(o.value+' '+o.textContent)):null);
      if(!match)return false;field.value=match.value;
    }else{
      const proto=field.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype;
      const setter=Object.getOwnPropertyDescriptor(proto,'value')?.set;
      if(setter)setter.call(field,String(value));else field.value=String(value);
    }
    field.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
    field.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
    return true;
  }
  function revealNative(reason){
    showNotice(reason||copy.form_unavailable);
    if(formSection){
      formSection.classList.add('awb-native-fallback');
      slot.classList.add('awb-native-fallback');
      slot.setAttribute('aria-hidden','false');slot.inert=false;
      if(successMonitor){clearInterval(successMonitor);successMonitor=null;}
      send.innerHTML=sendMarkup;
      requestAnimationFrame(()=>within(formSection,'[aria-invalid="true"],input,button').find(n=>!n.disabled)?.focus?.({preventScroll:true}));
      // Ensure native form is available in exceptional cases, not fake success.
    }
    contact.hidden=true;
    submitting=false;send.disabled=false;back.hidden=false;
  }
  const sendMarkup=send.innerHTML;
  const frame=()=>new Promise(resolve=>setTimeout(resolve,30));
  async function setBrand(value){
    const button=within(formSection,'button[aria-expanded]').find(n=>(n.getAttribute('aria-labelledby')||'').includes('hearing_aid_brand'));
    if(!button)return null;
    const ctx=button.getRootNode();
    const selected=()=>ctx.getElementById('custom#hearing_aid_brand-selector-value')?.textContent.trim()||'';
    const normal=s=>String(s).toLowerCase().replace(/[^a-z0-9]/g,'');
    if(normal(selected())===normal(value))return true;
    const wasInert=slot.inert;slot.inert=false;
    try{
    if(button.getAttribute('aria-expanded')!=='true')button.click();
    let options=[];
    for(let attempt=0;attempt<10;attempt++){
      await frame();
      const list=ctx.getElementById(button.getAttribute('aria-controls'));
      options=Array.from(list?.querySelectorAll('[role="option"]')||[]);
      if(options.length)break;
    }
    const option=options.find(n=>normal(n.textContent)===normal(value))||options.find(n=>/other.*not listed/i.test(n.textContent));
    if(!option){if(button.getAttribute('aria-expanded')==='true')button.click();return false;}
    const expected=option.textContent.trim();option.click();await frame();
    return selected()===expected;
    }finally{slot.inert=wasInert;}
  }
  function syncNative(){
    if(!fillPromise)fillPromise=fillNative().finally(()=>{fillPromise=null;});
    return fillPromise;
  }
  async function fillNative(transferPhoto=false){
    if(!ensureNativeForm())return null;
    const fields=within(formSection,'input,textarea,select').filter(e=>!e.disabled);
    if(!fields.length)return null;loading.hidden=true;
    const info=fields.map(f=>({f,about:describe(f)}));
    const nativeName=info.find(x=>x.f.type!=='hidden'&&x.f.type!=='email'&&/(^|\W)(full name|first name|your name|name|nombre|nom|vorname)(\W|$)/i.test(x.about)&&!/brand|device|model|company/i.test(x.about))?.f;
    const nativeEmail=fields.find(f=>f.type==='email')||info.find(x=>/email|e-mail|courriel/i.test(x.about))?.f;
    const nativeDescription=info.find(x=>x.f.tagName==='TEXTAREA'&&/idea|design|describe|message|bespoke|details|inspiration|enquiry|request/i.test(x.about))?.f||
      info.find(x=>x.f.tagName==='TEXTAREA')?.f;
    if(!nativeName||!nativeEmail||!nativeDescription)return null;
    setNative(nativeName,nameInput.value.trim());
    setNative(nativeEmail,emailInput.value.trim());
    setNative(nativeDescription,enquiryText());
    const nativeBudget=info.find(x=>x.f!==nativeDescription&&/budget|price range|spend|presupuesto|preisrahmen|prix/i.test(x.about))?.f;
    if(nativeBudget) setNative(nativeBudget,nativeBudget.type==='number'?state.budget.replace(/,/g,''):state.budget+' '+currencyCode);
    const customBrand=await setBrand(state.device?.brand||'Other / Not Listed');
    if(customBrand===false)return {reason:copy.form_unavailable};
    const brand=info.find(x=>x.f!==nativeDescription&&/hearing device brand|brand|manufacturer|marque|hersteller|fabricante/i.test(x.about))?.f;
    if(customBrand===null&&!brand)return {reason:copy.form_unavailable};
    if(brand){
      const brandValue=state.device?.brand||'Not sure';
      if(!setNative(brand,brandValue)&&brand.tagName==='SELECT'){
        // Keep required Shopify brand select complete when device will be confirmed later.
        const opts=Array.from(brand.options).filter(o=>o.value);
        const other=opts.find(o=>/other|not sure|unknown|not listed|autre|sonstige/i.test(o.textContent+' '+o.value));
        if(other)setNative(brand,other.value);
      }
    }
    const model=info.find(x=>x.f!==nativeDescription&&/make.*model|device.*model|hearing aid.*model|model/i.test(x.about))?.f;
    if(model)setNative(model,state.device?.model||copy.later);
    if(state.photo&&transferPhoto){
      const target=fields.find(f=>f.type==='file');
      if(!target)return {reason:copy.file_transfer};
      try{
        const dt=new DataTransfer();dt.items.add(state.photo);
        target.files=dt.files;
        target.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
        if(!target.files?.length)return {reason:copy.file_transfer};
      }catch{return {reason:copy.file_transfer};}
    }
    await frame();
    // Never attempt to submit an incomplete app form.
    const nform=within(formSection,'form').find(f=>f.querySelector('[type="submit"]'))||within(formSection,'form')[0];
    if(!nform)return null;
    const missing=fields.filter(f=>f.required&&!f.disabled&&((f.type==='checkbox'&&!f.checked)||(!['checkbox','radio','file','hidden'].includes(f.type)&&!f.value)||f.type==='file'&&!f.files?.length));
    if(missing.length||!nform.checkValidity())return {reason:copy.form_unavailable};
    return {form:nform};
  }
  function positiveConfirmation(){
    // Shopify Forms exposes its success step within a form-embed shadowRoot.
    // Read it as confirmation only when the step has genuinely advanced.
    const stages=within(formSection,'#app-embed[data-current-step],[data-current-step]');
    if(stages.some(n=>/success|submitted|thank.?you|complete|confirmation/i.test(n.getAttribute('data-current-step')||'')))return true;
    const nodes=within(formSection,'[class*="success"],[class*="Success"],[data-testid*="success"],[role="status"],h2,h3');
    const words=/thank you|thanks for|enquiry received|successfully|submitted successfully|merci|danke|gracias|grazie|obrigad|bedankt|ありがとう|감사|شكرا|شكراً/i;
    return nodes.some(n=>words.test(n.textContent||'')&&!n.closest?.('form'));
  }
  function showSuccess(){
    if(!submitting)return;
    submitting=false;send.disabled=false;
    if(successMonitor){clearInterval(successMonitor);successMonitor=null;}
    contact.hidden=true;showNotice('');
    complete.hidden=false;back.hidden=true;next.hidden=true;
    const pane=el('.awb-scroll');if(pane)pane.scrollTop=0;
    complete.querySelector('h2')?.setAttribute('tabindex','-1');
    complete.querySelector('h2')?.focus?.({preventScroll:true});
  }
  function trackSuccess(){
    let tries=0;
    if(successMonitor)clearInterval(successMonitor);
    successMonitor=setInterval(()=>{
      if(!dialog.open){clearInterval(successMonitor);successMonitor=null;return;}
      if(positiveConfirmation()){showSuccess();return;}
      if(within(formSection,'[aria-invalid="true"],[role="alert"]').some(n=>n.getAttribute('aria-invalid')==='true'||n.textContent.trim())){
        revealNative(copy.submit_error);return;
      }
      if(++tries>60){
        clearInterval(successMonitor);successMonitor=null;
        revealNative(copy.submit_error);
      }
    },250);
  }
  contact.addEventListener('change',()=>{syncNative().catch(()=>{});});
  contact.addEventListener('submit',async event=>{
    event.preventDefault();
    if(submitting)return;
    if(!nameInput.value.trim()){nameInput.focus();nameInput.reportValidity();return;}
    if(!emailInput.checkValidity()){emailInput.focus();emailInput.reportValidity();return;}
    showNotice('');
    submitting=true;send.disabled=true;send.textContent=copy.submit_wait||'Sending...';
    let done;
    try{await syncNative();done=await fillNative(true);}catch{revealNative(copy.form_unavailable);return;}
    if(!done?.form){revealNative(done?.reason||copy.form_unavailable);return;}
    const nativeSubmit=within(done.form,'button[type="submit"],input[type="submit"]')[0];
    submitting=true;send.disabled=true;send.textContent=copy.submit_wait||'Sending...';
    trackSuccess();
    try{
      const sendToShopify=()=>{
        if(!dialog.open||!submitting)return;
        try{
          if(nativeSubmit)nativeSubmit.click();
          else done.form.requestSubmit();
        }catch{revealNative(copy.submit_error);}
      };
      // Give Shopify Forms time to ingest a reference file after its change event.
      if(state.photo)setTimeout(sendToShopify,900);
      else sendToShopify();
    }catch{revealNative(copy.submit_error);}
  });
  if(location.hash==='#auzi-bespoke-enquiry'){
    window.addEventListener('load',()=>setTimeout(()=>openWizard(null),100),{once:true});
  }
})();
